import React from 'react'
import { Link } from 'react-router-dom'
import RoutesHelper from '../../../helpers/RoutesHelper'
import { Text } from 'components/base'
import slackLogo from 'assets/images/slack-app-icon.svg'

export default ({ note, hasIntegration }) => (
  <div>
    <div className="flexbox flexbox-align-center margin-bottom-large">
      <img
        src={slackLogo}
        alt="slack logo"
        style={{ width: 22, maxHeight: 22 }}
        className="margin-right-large"
      />
      <Text.Title>Share to Slack</Text.Title>
    </div>
    {hasIntegration === false && (
      <div className="border-small border-solid border-shade-40 shade-20 line-height-larger margin-bottom-large radius-normal padding-medium">
        Uh oh, it seems like your team admins haven't enabled the Slack
        integration yet!
        <br />
        <Link
          className="inline-block shade-20 bold underline margin-top-smallest"
          to={RoutesHelper.settingsIntegrations()}
        >
          Add the Slack integration
        </Link>
      </div>
    )}
    <div className="shade-10 line-height-larger font-size-large">
      This will share the entire doc to the selected Slack channel. <br />
      To share a doc to a private Slack Channel,{' '}
      <span className="bold">add @slitebot</span> to it.
    </div>
  </div>
)
